
var id = "KPITrend";
var markup = "<symbol viewBox=\"0 0 28 28\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"KPITrend\">\n    <title>Fill 1</title>\n    <g id=\"KPITrend_Page-1\" stroke=\"none\" stroke-width=\"1\" fill=\"none\" fill-rule=\"evenodd\">\n        <g id=\"KPITrend_品牌健康中心-新-copy\" transform=\"translate(-344.000000, -842.000000)\" fill=\"#1296DB\">\n            <g id=\"KPITrend_KPI-Trend---ALL\" transform=\"translate(304.000000, 802.000000)\">\n                <g id=\"KPITrend_Group-3\" transform=\"translate(40.000000, 40.000000)\">\n                    <path d=\"M26.7498971,0 L1.24775895,0 C0.557077103,0 -0.00234394293,0.559706423 -0.00234394293,1.25074061 L-0.00234394293,18.1357389 C-0.00234394293,18.826773 0.557077103,19.3864795 1.24775895,19.3864795 L26.7498971,19.3864795 C27.4405399,19.3864795 28,18.826773 28,18.1357389 L28,1.25074061 C28,0.559706423 27.4405399,0 26.7498971,0 Z M1.8728104,17.5103686 L26.1248457,17.5103686 L26.1248457,1.87611092 L1.8728104,1.87611092 L1.8728104,17.5103686 Z M21.1212307,25.513331 L6.74504737,25.513331 C6.2263328,25.513331 5.8074702,25.93229 5.8074702,26.4513865 C5.8074702,26.9704829 6.2263328,27.3894419 6.74504737,27.3894419 L21.1212307,27.3894419 C21.6400624,27.3894419 22.0588079,26.9704829 22.0588079,26.4513865 C22.0588079,25.935495 21.6400624,25.513331 21.1212307,25.513331 Z\" id=\"KPITrend_Fill-1\" />\n                </g>\n            </g>\n        </g>\n    </g>\n</symbol>";
(function injectSprite() {
  if (typeof document === 'undefined') return;
  var SPRITE_ID = '__UMI_SVG_SPRITE__';
  function ensure() {
    var root = document.getElementById(SPRITE_ID);
    if (!root) {
      root = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
      root.setAttribute('id', SPRITE_ID);
      root.setAttribute('aria-hidden', 'true');
      root.setAttribute('style', 'position:absolute;width:0;height:0;overflow:hidden');
      var parent = document.body || document.documentElement;
      parent.insertBefore(root, parent.firstChild);
    }
    if (document.getElementById(id)) return;
    try {
      root.insertAdjacentHTML('beforeend', markup);
      return;
    } catch (e) {}
    try {
      var doc = new DOMParser().parseFromString(
        '<svg xmlns="http://www.w3.org/2000/svg">' + markup + '</svg>',
        'image/svg+xml'
      );
      var node = doc.querySelector('symbol');
      if (node) root.appendChild(document.importNode(node, true));
    } catch (e2) {}
  }
  if (document.body || document.documentElement) ensure();
  else document.addEventListener('DOMContentLoaded', ensure);
})();
module.exports = id;
module.exports.default = id;
module.exports.id = id;
